<section class="learning-path-block block-container" [style.color]="block.textColor">
  @if (learningPathList?.length > 1 || block.title) {
    <div class="learning-path-block__header col-12 px-0 col-xl-8">
      <h1 [innerHtml]="block.title | safeHtml" [rtl]="block.langcode"></h1>
      @if (learningPathList?.length > 1) {
        <div class="learning-path-block__arrows" [style.color]="block.textColor">
          <button class="button button--icon button--transparent" mat-icon-button [disabled]="swiperComponent?.swiper?.isBeginning" (click)="swiperComponent?.swiper?.slidePrev()">
            <lib-icon icon="arrow-left"></lib-icon>
          </button>
          <div class="learning-path-block__arrows--slide-number">
            {{swiperComponent?.swiper?.activeIndex + 1}}/{{learningPathList?.length}}
          </div>
          <button class="button button--icon button--transparent" mat-icon-button [disabled]="swiperComponent?.swiper?.isEnd" (click)="swiperComponent?.swiper?.slideNext()">
            <lib-icon icon="arrow-right"></lib-icon>
          </button>
        </div>
      }
    </div>
  }
  <div class="learning-path-block__content row flex-column flex-lg-row">
    <div class="col-12 px-0 col-xl-8">
      <lib-swiper [slides]="learningPathList" [options]="swiperOptions">
        <ng-template swiperContent let-i="index" let-learningPath="item">
          <div class="slide">
            <div class="learning-path-block__card" (click)="navigateToLearningPath(learningPath, $event)">
              <div
                class="learning-path-block__card-image"
                [placeholderImage]="!learningPath.mediaImage && learningPath.bundle"
                [cropImage]="learningPath.mediaImage | preSignedUrl | async"
                [crop]="learningPath.mediaImage?.crop">
                @if (learningPath.deadline) {
                  <div class="learning-path-block__card-deadline" [class.overdue]="learningPath.overdue">
                    @if (!learningPath.overdue) {
                      {{'LEARNING_PATH.gain_points_deadline' | translate:{date: learningPath.deadline | customDate} }}
                    } @else {
                      {{'LEARNING_PATH.past_deadline' | translate:{date: learningPath.deadline | customDate} }}
                    }
                  </div>
                }
              </div>
              <div class="learning-path-block__card-content">
                <div
                  class="learning-path-block__card-content-image"
                  [placeholderImage]="!learningPath.mediaImage && learningPath.bundle"
                  [cropImage]="learningPath.mediaImage | preSignedUrl | async"
                  [crop]="learningPath.mediaImage?.crop"
                  imageWidth="200">
                </div>
                <div class="learning-path-block__card-details">
                  <div class="learning-path-block__card-details-header">
                    <div class="learning-path-block__card-details-header-title">{{'LEARNING_PATH.learning_path' | translate}}</div>
                  </div>
                  <div class="learning-path-block__card-details-title">{{learningPath.title}}</div>
                  @if (
                    (learningPath.progress && cardSettings?.progress?.visible)
                    || (learningPath.leaderboardPoint && cardSettings?.leaderboardPoints?.visible)
                    || (learningPath.time && cardSettings?.time?.visible)
                    || (learningPath.badge && cardSettings?.achievements?.visible)
                    || (learningPath.customCertificate && cardSettings?.certificate?.visible)) {
                    <div class="learning-path-block__card-details-footer">
                      @if (learningPath.progress && cardSettings?.progress?.visible) {
                        <lib-progress progressColor="primary" [progress]="learningPath.progress" [style.order]="cardSettings?.progress?.weight"></lib-progress>
                      }
                      @if (cardSettings?.steps?.visible) {
                        <span class="lessons-count" [style.order]="cardSettings?.steps?.weight">
                          <lib-icon icon="stack" [size]="16"></lib-icon>
                          {{learningPath.stepsCompleted}}/{{learningPath.stepsCount}} {{'COMMON.steps' | translate}}
                        </span>
                      }
                      @if (learningPath.time && cardSettings?.time?.visible) {
                        <div class="content-card__body--label-item" [style.order]="cardSettings?.time?.weight">
                          <lib-icon icon="clock" [size]="16"></lib-icon> {{learningPath.time | minutesToTime : 'short' }}
                        </div>
                      }
                      @if (learningPath.leaderboardPoints && cardSettings?.leaderboardPoints?.visible) {
                        <div [matTooltip]="'COMMON.content_complete_points' | translate:{points: learningPath.leaderboardPoints}" class="content-card__body--label-item" [style.order]="cardSettings?.leaderboardPoints?.weight">
                          <lib-icon icon="currency-eth" [size]="16"></lib-icon> {{learningPath.leaderboardPoints}} {{'LEADERBOARD.pts' | translate | lowercase}}
                        </div>
                      }
                      @if (learningPath.badge && cardSettings?.achievements?.visible) {
                        <div [matTooltip]="'COMMON.content_complete_achievements' | translate:{count: 1, content: learningPath.badge.title}" class="content-card__body--label-item" [style.order]="cardSettings?.achievements?.weight">
                          <lib-icon icon="medal" [size]="16"></lib-icon> {{'COMMON.achievement' | translate}}
                        </div>
                      }
                      @if (learningPath.customCertificate && cardSettings?.certificate?.visible) {
                        <div [matTooltip]="'COMMON.content_complete_certificate' | translate:{ certificate: learningPath.customCertificate.title }" class="content-card__body--label-item" [style.order]="cardSettings?.certificate?.weight">
                          <lib-icon icon="certificate" [size]="16"></lib-icon> {{'COMMON.certificate' | translate}}
                        </div>
                      }
                    </div>
                  }
                </div>
                @if (learningPath.progress !== 100) {
                  <div class="learning-path-block__card-button">
                    <button mat-flat-button class="button button--primary" (click)="navigateToLearningPath(learningPath, $event)">
                      <lib-icon icon="play"></lib-icon>
                      {{(learningPath.progress === 0 ? 'LEARNING_PATH.start_path' : 'LEARNING_PATH.continue_path') | translate }}
                    </button>
                  </div>
                }
              </div>
            </div>
          </div>
        </ng-template>
      </lib-swiper>
    </div>
    <div class="col-12 px-0 col-xl-4">
      <div class="learning-path-block__counter-list">
        <div class="learning-path-block__counter-item active-learning-paths">
          <div class="learning-path-block__counter-item__icon">
            <lib-icon icon="path" [duotone]="true" size="48"></lib-icon>
          </div>
          <div class="learning-path-block__counter-item__body">
            <div class="learning-path-block__counter-item__title">{{'LEARNING_PATH.n_active_learning_paths' | translate: {value: activeLearningPaths} }}</div>
            @if (activeLearningPaths) {
              <div class="learning-path-block__counter-item__subtitle">{{'COMMON.keep_learning' | translate }}</div>
            }
          </div>
        </div>
        <div class="learning-path-block__counter-item completed-learning-paths">
          <div class="learning-path-block__counter-item__icon">
            <lib-icon icon="flag-banner" [duotone]="true" size="48"></lib-icon>
          </div>
          <div class="learning-path-block__counter-item__body">
            <div class="learning-path-block__counter-item__title">{{'LEARNING_PATH.n_finished_learning_paths' | translate: {value: completedLearningPaths} }}</div>
            @if (completedLearningPaths) {
              <div class="learning-path-block__counter-item__subtitle">{{'LESSON_FEEDBACK.well_done' | translate}}</div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<ng-template #nextLessonLoadingTmp>
  <mat-spinner diameter="40"></mat-spinner>
</ng-template>
